:host {
  display: block;
  position: relative;
}

.subscription-payment {
  display: grid;
  gap: 0.5em;
}
